import { InputState } from '@kubit/web-ui-components/input/types';
import { withDropdownCommonStyles } from '../commonStyles';
import { InputPhoneVariant } from '../variants';
export const getRegularWithPrefixDropdownStyles = (FOUNDATIONS, FONT) => {
    return {
        [InputPhoneVariant.REGULAR_WITH_PREFIX_DROPDOWN]: {
            [InputState.EMPTY]: {
                ...withDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.FILLED]: {
                ...withDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.ACTIVE]: {
                ...withDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.DISABLED_EMPTY]: {
                ...withDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.DISABLED_FILLED]: {
                ...withDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.DISABLED_FILLED_WITH_INFO]: {
                ...withDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_EMPTY]: {
                ...withDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_FILLED]: {
                ...withDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_ACTIVE]: {
                ...withDropdownCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_FILLED_WITH_INFO]: {
                ...withDropdownCommonStyles(FOUNDATIONS, FONT),
            },
        },
    };
};
//# sourceMappingURL=regularWithPrefixDropdown.js.map